import { TextButton } from '@amzn/storm-ui';
import React from 'react';
import styled from 'styled-components';
import { Breadcrumb } from 'src/app/slice';
import { getBreadcrumbLabel } from './breadcrumbsHelper';
import { StyledLink } from './style';
import { LaunchFlag } from 'src/commons/components/LaunchFlag/LaunchFlag';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';

const StyledTextButton = styled(TextButton)`
  text-decoration: none;

  &:focus {
    outline-offset: -1px;
  }

  &:hover {
    text-decoration: underline;
  }

  &&& + span {
    color: ${({ theme }) => theme.color.gray[500]};
    margin-bottom: -2px;
  }
`;

export const LinkBreadcrumb: React.FC<{ breadcrumb: Breadcrumb }> = ({
  breadcrumb,
}) => {
  if (breadcrumb.onClickCallback) {
    return (
      <StyledTextButton onClick={breadcrumb.onClickCallback}>
        {getBreadcrumbLabel(breadcrumb)}
        {!!breadcrumb.objectSuffix && (
          <LaunchFlag flag={{ type: 'beta', label: breadcrumb.objectSuffix }} />
        )}
      </StyledTextButton>
    );
  }

  return (
    <StyledLink
      href={breadcrumb.url}
      ia2Enabled={true}
      {...getTaktAttributes(
        `link-breadcrumb`,
        chromeComponents.HEADER,
        breadcrumb.url ? { url: breadcrumb.url, label: breadcrumb.label } : {},
      )}
    >
      {getBreadcrumbLabel(breadcrumb)}
      {!!breadcrumb.objectSuffix && (
        <LaunchFlag flag={{ type: 'beta', label: breadcrumb.objectSuffix }} />
      )}
    </StyledLink>
  );
};
